import { Module } from "@/modules/centralWebsite/enums";
import type { RouteRecordRaw } from "vue-router";
import { useTenantOnboardingIdStorage } from "@/modules/centralWebsite/tenantRegistration/composables/tenantRegistrationStorage";

export default <RouteRecordRaw[]>[
  {
    path: "/",
    meta: {
      module: Module.TenantRegistration,
    },
    children: [
      {
        path: ":onboardingId/machtiging-afgeven",
        name: "tenantRegistration.acceptAgreements",
        component: () =>
          import("@/modules/centralWebsite/tenantRegistration/views/TenantRegistrationAcceptAgreements.vue"),
      },
      {
        path: "",
        name: "tenantRegistration.show",
        component: () =>
          import("@/modules/centralWebsite/tenantRegistration/views/TenantRegistrationView.vue"),
      },
      {
        path: "aanmelden/gelukt",
        name: "tenantRegistration.success",
        component: () =>
          import("@/modules/centralWebsite/tenantRegistration/views/TenantRegistrationSuccessView.vue"),
      },
      {
        path: "aanmelden/mislukt",
        redirect: () => {
          const storedTenantId = useTenantOnboardingIdStorage();

          if (storedTenantId.value) {
            return {
              name: "tenantRegistration.acceptAgreements",
              params: { onboardingId: storedTenantId.value },
              query: { failed: "true" },
            };
          }

          return {
            name: "tenantRegistration.show",
            query: { failed: "true" },
          };
        },
      },
    ],
  },
];
